import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _1xMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"1x_mobiledata"}/>
}
